import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getUserTimezone } from '../../shared/utils/date.util';

/**
 * Adds `x-timezone` when shop location state is available in localStorage.
 * Uses shop timezone from `shop_location_state` (selected ?? default).
 */
@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const timezone = getUserTimezone();
    if (!timezone) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          'x-timezone': timezone
        }
      })
    );
  }
}
